import { CHECKIN_ROUTES } from '@conf/routes.config';
/**
 * コンテンツ領域にて l-wrap__inner を無効にするURL
 */
export const DISABLED_WRAP_INNER_URLS = [
  `/${CHECKIN_ROUTES.checkinSelect}`,
  `/${CHECKIN_ROUTES.passengerInput}`,
  `/${CHECKIN_ROUTES.checkinCompleted}`,
  `/${CHECKIN_ROUTES.checkinMybooking}`,
  `/${CHECKIN_ROUTES.waitingNumber}`,
  `/${CHECKIN_ROUTES.standbyCompleted}`,
] as string[];
